import { signInWithEmailAndPassword, signOut } from "firebase/auth";
import {
  collection,
  getDoc,
  doc,
  getDocs,
  updateDoc,
  setDoc,
  query,
  orderBy,
  limit,
  startAfter,
} from "firebase/firestore";
import commontext from "../constants/commontext";
import { FirebaseAuth, FirestoreDb } from "../firebaseutils/firebase";
import AwsCredentials from "../utils/awsCredentials";
import { isEmptyOrNull } from "../utils/inputvalidation";
import {
  getKeyPrefix,
  getKeyPrefixForm3u8,
  getKeyPrefixForMp4,
  getKeyPrefixFormStreamingFolder,
} from "../utils/helper";
import _ from "lodash";
import environmentVariable from "../utils/environmentVariable";
import axios from "axios";

const loginWithEmailPassword = (email, password) => {
  return new Promise((resolve, reject) => {
    signInWithEmailAndPassword(FirebaseAuth, email, password)
      .then((user) => {
        resolve(getAdminInfoFromDatabase(user.user));
      })
      .catch((error) => {
        reject({
          success: false,
          isError: true,
          response: error,
        });
      });
  });
};

const getAdminInfoFromDatabase = (user) => {
  return new Promise(async (resolve, reject) => {
    const docRef = doc(FirestoreDb, commontext.usersCollection, user.uid);
    getDoc(docRef)
      .then((docSnap) => {
        if (docSnap.exists()) {
          let userData = docSnap.data();
          let userRole = userData.userRole;
          if (
            userRole == commontext.adminText1 ||
            userRole == commontext.adminText2
          ) {
            resolve({
              success: true,
              isError: false,
              response: userData,
            });
          } else {
            resolve({
              success: false,
              isError: false,
              message: commontext.adminCredentialRequired,
            });
          }
        } else {
          resolve({
            success: false,
            isError: false,
            message: commontext.somethingWentWrong,
          });
        }
      })
      .catch((error) => {
        resolve({
          success: false,
          isError: true,
          response: error,
          message: commontext.somethingWentWrong,
        });
      });
  });
};

const signOutFromApp = () => {
  return new Promise((resolve, reject) => {
    signOut(FirebaseAuth)
      .then(() => {
        resolve({
          success: true,
          isError: false,
        });
      })
      .catch((error) => {
        reject({
          success: false,
          isError: true,
          response: error,
        });
      });
  });
};

const getWorkoutDataFromDatabase = () => {
  return new Promise(async (resolve, reject) => {
    try {
      let querySnapshot = await getDocs(
        collection(FirestoreDb, commontext.workoutCollection)
      );
      let requiredList = querySnapshot.docs.map((obj) => obj.data());
      requiredList = requiredList.filter((obj) => obj.workoutType);
      resolve({
        success: true,
        isError: false,
        response: requiredList,
      });
    } catch (error) {
      reject({
        success: false,
        isError: true,
        response: error,
      });
    }
  });
};

const getDataForPerticularWorkout = (data) => {
  return new Promise(async (resolve, reject) => {
    let routeList = [...data];
    let mainWorkout = routeList.find((obj) => obj.level_id === 1);
    let mainEnvWorkout = routeList.find((obj) => obj.level_id === 2);
    try {
      const docRef = doc(
        FirestoreDb,
        commontext.workoutCollection,
        mainWorkout?.title
      );
      const docSnap = await getDoc(docRef);
      let docWorkout = docSnap.data();

      if (!isEmptyOrNull(mainEnvWorkout)) {
        let allEnvData = [...docWorkout.data];
        let requiredEnvData = allEnvData.find(
          (obj) => obj.title == mainEnvWorkout.title
        );
        if (!isEmptyOrNull(requiredEnvData)) {
          let subEnvWorkout = routeList.find((obj) => obj.level_id === 3);

          let allSubEnvData = [...requiredEnvData.data];
          let requiredSubEnvData = allSubEnvData.find(
            (obj) => obj.title == subEnvWorkout.title
          );

          if (!isEmptyOrNull(requiredSubEnvData)) {
            let finalWorkoutData = routeList.find((obj) => obj.level_id === 4);

            let allSubEnvWorkoutData = [...requiredSubEnvData.workouts];
            let requiredSubEnvWorkoutData = allSubEnvWorkoutData.find(
              (obj) => obj.workoutName == finalWorkoutData.title
            );
            resolve({
              success: true,
              error: false,
              response: requiredSubEnvWorkoutData,
            });
          } else {
            resolve({
              success: false,
              error: true,
              response: null,
            });
          }
        } else {
          resolve({
            success: false,
            error: true,
            response: null,
          });
        }
      } else {
        let finalWorkoutData = routeList.find((obj) => obj.level_id === 4);

        let allSubEnvWorkoutData = [...docWorkout.data.workouts];
        let requiredSubEnvWorkoutData = allSubEnvWorkoutData.find(
          (obj) => obj.workoutName == finalWorkoutData.title
        );
        resolve({
          success: true,
          error: false,
          response: requiredSubEnvWorkoutData,
        });
      }
    } catch (error) {
      resolve({
        success: false,
        error: true,
        response: error,
      });
    }
  });
};

const getLisOfMainWorkoutWithSubmittedVideo = (
  breadcrumbs,
  workoutListData,
  response,
  fileName,
  videoDuration,
  videoTitle,
  videoDescription,
  requiedObj
) => {
  return new Promise((resolve, reject) => {
    let routeList = [...breadcrumbs];
    let mainWorkout = routeList.find((obj) => obj.level_id === 1);
    let mainEnvWorkout = routeList.find((obj) => obj.level_id === 2);
    let workoutListDataUpdate = [...workoutListData];
    let mainWorkoutData = workoutListDataUpdate.find(
      (obj) => obj.workoutType == mainWorkout.title
    );
    if (!isEmptyOrNull(mainEnvWorkout)) {
      let subEnvWorkout = routeList.find((obj) => obj.level_id === 3);
      let finalWorkoutData = routeList.find((obj) => obj.level_id === 4);
      let mainEnvWorkoutData = mainWorkoutData?.data?.map((obj) => {
        if (obj.title == mainEnvWorkout.title) {
          delete obj.parentNode;
          return {
            ...obj,
            data: obj?.data?.map((obj2) => {
              if (obj2.title == subEnvWorkout.title) {
                delete obj2.parentNode;
                return {
                  ...obj2,
                  workouts: obj2?.workouts?.map((obj3) => {
                    if (obj3.workoutName == finalWorkoutData.title) {
                      let workoutVideosList = [...obj3.workoutVideos];
                      workoutVideosList.push({
                        ...requiedObj,
                      });
                      delete obj3.parentNode;
                      return {
                        ...obj3,
                        workoutVideos: workoutVideosList.map((obj4) => {
                          delete obj4.parentNode;
                          return obj4;
                        }),
                      };
                    } else {
                      delete obj3.parentNode;
                      let workoutVideosList = obj3.workoutVideos;
                      return {
                        ...obj3,
                        workoutVideos: workoutVideosList.map((obj4) => {
                          delete obj4.parentNode;
                          return obj4;
                        }),
                      };
                    }
                  }),
                };
              } else {
                delete obj2.parentNode;
                return {
                  ...obj2,
                  workouts: obj2?.workouts?.map((obj3) => {
                    delete obj3.parentNode;
                    return {
                      ...obj3,
                      workoutVideos: obj3?.workoutVideos?.map((obj4) => {
                        delete obj4.parentNode;
                        return obj4;
                      }),
                    };
                  }),
                };
              }
            }),
          };
        } else {
          delete obj.parentNode;
          return {
            ...obj,
            data: obj.data.map((obj2) => {
              delete obj2.parentNode;
              return {
                ...obj2,
                workouts: obj2?.workouts?.map((obj3) => {
                  delete obj3.parentNode;
                  return {
                    ...obj3,
                    workoutVideos: obj3?.workoutVideos?.map((obj4) => {
                      delete obj4.parentNode;
                      return obj4;
                    }),
                  };
                }),
              };
            }),
          };
        }
      });
      mainWorkoutData = {
        ...mainWorkoutData,
        data: mainEnvWorkoutData,
      };
    } else {
      let finalWorkoutData = routeList.find((obj) => obj.level_id === 4);
      let allSubEnvWorkoutData = [...mainWorkoutData.data.workouts];
      let subWorkoutUpdatedList = [];
      allSubEnvWorkoutData.map((obj5) => {
        if (obj5.workoutName == finalWorkoutData.title) {
          let workoutVideosList = [...obj5.workoutVideos];
          workoutVideosList.push({
            ...requiedObj,
          });

          subWorkoutUpdatedList.push({
            ...obj5,
            workoutVideos: workoutVideosList,
          });
        } else {
          delete obj5.parentNode;
          let workoutVideosList = obj5.workoutVideos;

          subWorkoutUpdatedList.push({
            ...obj5,
            workoutVideos: workoutVideosList,
          });
        }
      });
      let { data, ...rest2 } = mainWorkoutData;
      let { workouts, ...rest3 } = data;
      mainWorkoutData = {
        ...rest2,
        data: {
          ...rest3,
          workouts: subWorkoutUpdatedList,
        },
      };
    }
    mainWorkoutData.parentNode = {};
    resolve(mainWorkoutData);
  });
};

const storeUploadedVideoUrlInFirestore = (data, dataNeedToStore) => {
  return new Promise(async (resolve, reject) => {
    let routeList = [...data];
    let mainWorkout = routeList.find((obj) => obj.level_id === 1);
    try {
      const docRef = doc(
        FirestoreDb,
        commontext.workoutCollection,
        mainWorkout.title
      );
      updateDoc(docRef, JSON.parse(JSON.stringify(dataNeedToStore)))
        .then(() => {
          resolve({
            success: true,
          });
        })
        .catch((error) => {
          reject({
            success: false,
            isError: true,
            response: error,
          });
        });
    } catch (error) {
      reject({
        success: false,
        isError: true,
        response: error,
      });
    }
  });
};

const getPreSignedUploadUrl = (fileName, breadcrumbs) => {
  return new Promise(async (resolve, reject) => {
    try {
      let formattedKeyPrefix = breadcrumbs;
      formattedKeyPrefix = formattedKeyPrefix
        .map((obj) => obj.title.replace(/[&/\\]/g, ""))
        .join("/");

      const key = getKeyPrefix(formattedKeyPrefix, fileName);
      const bucketName =
        environmentVariable.APP_ENVIRONMENT == "DEV"
          ? AwsCredentials.phalanxS3Bucket_dev
          : AwsCredentials.phalanxS3Bucket_stag;

      // Call Firebase Cloud Function to get pre-signed URL
      // Note: You'll need to create this cloud function on your backend
      const cloudFunctionUrl =
        environmentVariable.APP_ENVIRONMENT == "DEV"
          ? "https://us-central1-phalanx-develop.cloudfunctions.net/getPreSignedUploadUrl"
          : "https://us-central1-phalanx-staging.cloudfunctions.net/getPreSignedUploadUrl";

      axios({
        method: "POST",
        url: cloudFunctionUrl,
        headers: {
          "Content-Type": "application/json",
        },
        data: {
          bucket: bucketName,
          key: key,
          contentType: "video/mp4",
        },
      })
        .then((response) => {
          if (environmentVariable.ENABLE_UPLOAD_LOGS !== false) {
            console.log("====================================");
            console.log("response.data===> ", response.data);
            console.log("====================================");
          }
          resolve({
            success: true,
            preSignedUrl: response.data.url,
            key: key,
            bucket: bucketName,
          });
        })
        .catch((error) => {
          if (environmentVariable.ENABLE_UPLOAD_LOGS !== false) {
            console.error("Error getting pre-signed URL:", error);
          }
          reject({
            success: false,
            isError: true,
            response: error,
          });
        });
    } catch (error) {
      reject({
        success: false,
        isError: true,
        response: error,
      });
    }
  });
};

const uploadVideoToS3BucketWithProgress = (
  video,
  fileName,
  breadcrumbs,
  progressCallBack,
  options = {}
) => {
  return new Promise(async (resolve, reject) => {
    try {
      // Determine if logging is enabled (can be overridden per call or use global setting)
      const enableLogs =
        options.enableLogs !== undefined
          ? options.enableLogs
          : environmentVariable.ENABLE_UPLOAD_LOGS !== false;

      // First, get the pre-signed URL
      const preSignedUrlResponse = await getPreSignedUploadUrl(
        fileName,
        breadcrumbs
      );

      if (!preSignedUrlResponse.success) {
        reject(preSignedUrlResponse);
        return;
      }

      const { preSignedUrl, key, bucket } = preSignedUrlResponse;

      // Record upload start time
      const uploadStartTime = Date.now();

      if (enableLogs) {
        console.log(`🚀 Starting upload: ${fileName}`);
      }

      // Upload using XMLHttpRequest to track progress
      const xhr = new XMLHttpRequest();

      // Track upload progress
      xhr.upload.addEventListener("progress", (event) => {
        if (event.lengthComputable) {
          const percent = Math.round((event.loaded / event.total) * 100);
          const elapsedTime = (Date.now() - uploadStartTime) / 1000; // in seconds
          const elapsedMinutes = Math.floor(elapsedTime / 60);
          const elapsedSeconds = Math.floor(elapsedTime % 60);

          // Calculate estimated time remaining
          const remainingBytes = event.total - event.loaded;
          const uploadSpeed = event.loaded / elapsedTime; // bytes per second
          const estimatedTimeRemaining =
            uploadSpeed > 0 ? remainingBytes / uploadSpeed : 0;
          const estimatedMinutesRemaining = Math.floor(
            estimatedTimeRemaining / 60
          );
          const estimatedSecondsRemaining = Math.floor(
            estimatedTimeRemaining % 60
          );

          progressCallBack({
            isProgress: true,
            isSuccess: true,
            response: {
              loaded: event.loaded,
              total: event.total,
              percent: percent,
              key: key,
              elapsedTime: elapsedTime, // in seconds
              elapsedTimeMinutes: elapsedMinutes,
              elapsedTimeSeconds: elapsedSeconds,
              elapsedTimeFormatted: `${elapsedMinutes}m ${elapsedSeconds}s`,
              estimatedTimeRemaining: estimatedTimeRemaining, // in seconds
              estimatedTimeRemainingMinutes: estimatedMinutesRemaining,
              estimatedTimeRemainingSeconds: estimatedSecondsRemaining,
              estimatedTimeRemainingFormatted: `${estimatedMinutesRemaining}m ${estimatedSecondsRemaining}s`,
              uploadSpeed: uploadSpeed, // bytes per second
            },
          });
        }
      });

      // Handle completion
      xhr.addEventListener("load", () => {
        if (xhr.status === 200 || xhr.status === 204) {
          // Calculate total upload time
          const uploadEndTime = Date.now();
          const totalUploadTime = (uploadEndTime - uploadStartTime) / 1000; // in seconds
          const totalMinutes = Math.floor(totalUploadTime / 60);
          const totalSeconds = Math.floor(totalUploadTime % 60);
          const totalTimeFormatted = `${totalMinutes}m ${totalSeconds}s`;

          // Extract location from pre-signed URL (remove query parameters)
          const location = preSignedUrl.split("?")[0];

          if (enableLogs) {
            console.log(
              `✅ Video uploaded successfully in ${totalTimeFormatted} (${totalUploadTime.toFixed(
                2
              )} seconds)`
            );
          }

          resolve({
            success: true,
            response: {
              Key: key,
              Location: location,
              key: key,
              location: location,
              uploadTime: totalUploadTime, // in seconds
              uploadTimeMinutes: totalMinutes,
              uploadTimeSeconds: totalSeconds,
              uploadTimeFormatted: totalTimeFormatted,
            },
          });
        } else {
          const uploadEndTime = Date.now();
          const totalUploadTime = (uploadEndTime - uploadStartTime) / 1000;
          reject({
            success: false,
            isError: true,
            response: {
              status: xhr.status,
              statusText: xhr.statusText,
              message: "Upload failed",
              uploadTime: totalUploadTime,
            },
          });
        }
      });

      // Handle errors
      xhr.addEventListener("error", () => {
        const uploadEndTime = Date.now();
        const totalUploadTime = (uploadEndTime - uploadStartTime) / 1000;
        const totalMinutes = Math.floor(totalUploadTime / 60);
        const totalSeconds = Math.floor(totalUploadTime % 60);
        const totalTimeFormatted = `${totalMinutes}m ${totalSeconds}s`;

        if (enableLogs) {
          console.error(`❌ Upload failed after ${totalTimeFormatted}`);
        }
        reject({
          success: false,
          isError: true,
          response: {
            message: "Network error during upload",
            uploadTime: totalUploadTime,
            uploadTimeFormatted: totalTimeFormatted,
          },
        });
      });

      xhr.addEventListener("abort", () => {
        const uploadEndTime = Date.now();
        const totalUploadTime = (uploadEndTime - uploadStartTime) / 1000;
        const totalMinutes = Math.floor(totalUploadTime / 60);
        const totalSeconds = Math.floor(totalUploadTime % 60);
        const totalTimeFormatted = `${totalMinutes}m ${totalSeconds}s`;

        if (enableLogs) {
          console.warn(`⚠️ Upload aborted after ${totalTimeFormatted}`);
        }
        reject({
          success: false,
          isError: true,
          response: {
            message: "Upload aborted",
            uploadTime: totalUploadTime,
            uploadTimeFormatted: totalTimeFormatted,
          },
        });
      });

      // Start the upload
      xhr.open("PUT", preSignedUrl);
      xhr.setRequestHeader("Content-Type", "video/mp4");
      xhr.send(video);
    } catch (error) {
      reject({
        success: false,
        isError: true,
        response: error,
      });
    }
  });
};

const getPurchasedVideosList = () => {
  return new Promise((resolve, reject) => {
    try {
      axios({
        method: "GET",
        url:
          environmentVariable.APP_ENVIRONMENT == "DEV"
            ? "https://us-central1-phalanx-develop.cloudfunctions.net/getPurchasedCollectionList"
            : "https://us-central1-phalanx-staging.cloudfunctions.net/getPurchasedCollectionList",
      })
        .then((response) => {
          resolve({
            success: true,
            response: response,
            isError: false,
          });
        })
        .catch((error) => {
          console.error("error===> ", error);
          reject({
            success: false,
            isError: true,
            response: error,
          });
        });
    } catch (error) {
      reject({
        success: false,
        isError: true,
        response: error,
      });
    }
  });
};

const deleteVideoFromAws = async (fileName, breadcrumbs) => {
  return new Promise(async (resolve, reject) => {
    try {
      let formattedKeyPrefix = breadcrumbs;
      // formattedKeyPrefix = formattedKeyPrefix.map(obj => obj.title.replace(/[&/\\]/g, "")).join("/");

      let keyPrefix = getKeyPrefixForMp4(formattedKeyPrefix, fileName);
      let keyPrefixform3u8 = getKeyPrefixForm3u8(formattedKeyPrefix, fileName);
      let keyPrefixformStreamingFolder = getKeyPrefixFormStreamingFolder(
        formattedKeyPrefix,
        fileName
      );

      let bucketName =
        environmentVariable.APP_ENVIRONMENT == "DEV"
          ? AwsCredentials.phalanxS3Bucket_dev
          : AwsCredentials.phalanxS3Bucket_stag;

      // Call Firebase Cloud Function to delete video
      const cloudFunctionUrl =
        environmentVariable.APP_ENVIRONMENT == "DEV"
          ? "https://us-central1-phalanx-develop.cloudfunctions.net/deleteVideoFromS3"
          : "https://us-central1-phalanx-staging.cloudfunctions.net/deleteVideoFromS3";

      axios({
        method: "POST",
        url: cloudFunctionUrl,
        headers: {
          "Content-Type": "application/json",
        },
        data: {
          bucket: bucketName,
          mp4Key: keyPrefix,
          m3u8Key: keyPrefixform3u8,
          streamFolderKey: keyPrefixformStreamingFolder,
          region: AwsCredentials.region,
        },
      })
        .then((response) => {
          resolve({
            success: true,
            response: response.data.response,
            isError: false,
          });
        })
        .catch((error) => {
          console.error("Error deleting video from S3:", error);
          reject({
            success: false,
            isError: true,
            response: error,
          });
        });
    } catch (error) {
      reject({
        success: false,
        isError: true,
        response: error,
      });
    }
  });
};

const getAllListOfPromoTable = () => {
  return new Promise(async (resolve, reject) => {
    try {
      let querySnapshot = await getDocs(
        collection(FirestoreDb, commontext.promoCodeCollection)
      );
      let requiredList = querySnapshot.docs.map((obj) => obj.data());
      // requiredList = requiredList.filter((obj) => obj.workoutType)
      resolve({
        success: true,
        isError: false,
        response: requiredList,
      });
    } catch (error) {
      console.log("Error:", error);
      reject({
        success: false,
        isError: true,
        response: error,
      });
    }
  });
};

const setPromoToStoreList = (promoData, docId) => {
  return new Promise(async (resolve, reject) => {
    try {
      await setDoc(doc(FirestoreDb, commontext.promoCodeCollection, docId), {
        ...promoData,
      });
      resolve({
        success: true,
        isError: false,
      });
    } catch (error) {
      console.log("Error:", error);
      reject({
        success: false,
        isError: true,
        response: error,
      });
    }
  });
};

const getPromoListForFirstPage = () => {
  return new Promise(async (resolve, reject) => {
    try {
      const first = query(
        collection(FirestoreDb, commontext.promoCodeCollection),
        orderBy("date_created", "desc"),
        limit(10)
      );
      const documentSnapshots = await getDocs(first);
      let requiredList = documentSnapshots.docs.map((obj) => obj.data());

      resolve({
        success: true,
        isError: false,
        response: requiredList,
      });
    } catch (error) {
      console.log("Error:", error);
      reject({
        success: false,
        isError: true,
        response: error,
      });
    }
  });
};

const getPromoListForPagination = async (lastVisible) => {
  return new Promise(async (resolve, reject) => {
    try {
      const next = query(
        collection(FirestoreDb, commontext.promoCodeCollection),
        orderBy("date_created", "desc"),
        startAfter(lastVisible),
        limit(10)
      );
      const documentSnapshots = await getDocs(next);
      let requiredList = documentSnapshots.docs.map((obj) => obj.data());

      resolve({
        success: true,
        isError: false,
        response: requiredList,
      });
    } catch (error) {
      console.log("Error:", error);
      reject({
        success: false,
        isError: true,
        response: error,
      });
    }
  });
};

const services = {
  signOutFromApp,
  loginWithEmailPassword,
  getAdminInfoFromDatabase,
  getWorkoutDataFromDatabase,
  getDataForPerticularWorkout,
  storeUploadedVideoUrlInFirestore,
  getLisOfMainWorkoutWithSubmittedVideo,
  uploadVideoToS3BucketWithProgress,
  getPurchasedVideosList,
  deleteVideoFromAws,
  getAllListOfPromoTable,
  setPromoToStoreList,
  getPromoListForFirstPage,
  getPromoListForPagination,
};

export default services;
